import { Box, Button, Card, CardBody, CardFooter, CardHeader, Center, Flex, HStack, Heading, Input, InputGroup, InputLeftAddon, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Spacer, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Textarea, VStack, useClipboard, useToast } from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";
import React, { SetStateAction, useEffect, useState } from "react";
import { sendTransaction, signTransaction } from '@joyid/evm';
import { NavBar } from "../../components/NavBar";
import { Footer } from "../../components/Footer";
import { ViewData } from "../../data/ViewData";
import { ImageUtils } from "../../utils/ImageUtils";
import { EvmWorker } from "../../client/EvmWorker";
import { ChainsInfo } from "../../data/ChainsInfo";
import { JoyIDEvmWallet } from "../../client/JoyIDEvmWallet";
import { EvmRoutes } from "../../data/RoutesData";
import { parseEther } from "ethers";

export const EvmPage = () => {
    const [currentChain, setCurrentChain] = useState("");
    const [ethStatus, setEthStatus] = useState("gray");
    const [polygonStatus, setPolygonStatus] = useState("gray");
    const [protocol, setProtocol] = useState("brc-20");

    const [deployTick, setDeployTick] = useState("");
    const [deployTotalSupply, setDeployTotalSupply] = useState(21000000);
    const [deployLimitPerMint, setDeployLimitPerMint] = useState(1000);
    const [deployText, setDeployText] = useState("");
    const [deployHex, setDeployHex] = useState("");
    const [deploying, setDeploying] = useState(false);

    const [mintTick, setMintTick] = useState("");
    const [mintAmount, setMintAmount] = useState(1000);
    const [mintText, setMintText] = useState("");
    const [mintHex, setMintHex] = useState("");
    const [minting, setMinting] = useState(false);

    const btnColorUnselected = "gray", btnColorSelected = "teal";
    //let joyidProvider: JoyIDProvider;
    const toast = useToast();

    const resetChainsButtons = () => {
        setEthStatus(btnColorUnselected);
        setPolygonStatus(btnColorUnselected);
    }
    const switchChain = async (chainName: string, networkInfo: any, setButtonStatus: any) => {
        resetChainsButtons();
        try{
            //await EvmWorker.requestNetwork(networkInfo.requestParams);
            JoyIDEvmWallet.switchNetwork(chainName, networkInfo); //joyidProvider = JoyIDWallet.createProvider(chainName, networkInfo);
            setButtonStatus(btnColorSelected);
            setCurrentChain(chainName);
        }
        catch {
        }
    }
    // const submitTx = async (ether: string, data: string) => {
    //     const value = parseEther(ether);
    //     const txhash = await sendTransaction({
    //             to: ViewData.ethAddress,
    //             value: value.toString(),
    //             data: data
    //         },
    //         ViewData.ethAddress,
    //     );
    //     return txhash;
    // }

    const updateDeployContent = () => {
        const text = `data:,{"p":"${protocol}","op":"deploy","tick":"${deployTick}","max":"${deployTotalSupply}","lim":${deployLimitPerMint}}`;
        setDeployText(text);
        return text;
    }
    const updateDeployHex = (text: string) => {
        const hex = Buffer.from(text).toString('hex');
        setDeployHex(`0x${hex}`);
    }
    const prepareDeploy = () => {
        const txt = updateDeployContent();
        updateDeployHex(txt);
    }
    const deploy = async () => {
        setDeploying(true);
        try{
            const txhash = await JoyIDEvmWallet.submitTx("0", deployHex, ViewData.ethAddress, ViewData.ethAddress);
            toast({
                title: 'Success!',
                description: `Deploy Tx: ${txhash}`,
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        }
        catch {
            toast({
                title: 'Failed',
                description: "Failed to submit deployment transaction!",
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
        finally { setDeploying(false); }
    }

    const updateMintContent = () => {
        const text = `data:,{"p":"${protocol}","op":"mint","tick":"${mintTick}","amt":"${mintAmount}"}`;
        setMintText(text);
        return text;
    }
    const updateMintHex = (text: string) => {
        const hex = Buffer.from(text).toString('hex');
        setMintHex(`0x${hex}`);
    }
    const prepareMint = () => {
        const txt = updateMintContent();
        updateMintHex(txt);
    }
    const mint = async () => {
        setMinting(true);
        try{
            const txhash = await JoyIDEvmWallet.submitTx("0", mintHex, ViewData.ethAddress, ViewData.ethAddress);
            toast({
                title: 'Success!',
                description: `Mint Tx: ${txhash}`,
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        }
        catch {
            toast({
                title: 'Failed',
                description: "Failed to submit mint transaction!",
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
        finally { setMinting(false); }
    }
    return (
        <VStack spacing={4}>
            <NavBar />
            <Center p={3}>
                <Heading as='h2' size='xl' bg="red">Click one chain first!</Heading>
            </Center>
            <Stack direction='row' spacing={4} align='center'>
                <Button colorScheme={ethStatus} isDisabled={true}
                    onClick={() => {
                        switchChain(EvmRoutes.ethereum.title, ChainsInfo.ethereum.mainnet, setEthStatus);
                        setProtocol("erc-20");
                    }}>Ethereum</Button>
                <Button colorScheme={polygonStatus}
                    onClick={() => {
                        switchChain(EvmRoutes.polygon.title, ChainsInfo.polygon.mainnet, setPolygonStatus);
                        setProtocol("prc-20");
                    }}>Polygon</Button>
            </Stack>
            <Center p={3}>
                <Heading as='h2' size='xl'>{currentChain}</Heading>
            </Center>
            <Center p={3}>
                <Heading as='h2' size='xl' bg="red">Pay attention to the protocol name!</Heading>
            </Center>
            <Center p={3} width="md">
                <InputGroup>
                    <InputLeftAddon children='Protocol' bg="red" />
                    <Input type='text' placeholder='brc-20' value={protocol} color="red"
                        onChange={e => {
                            setProtocol(e.target.value);
                        } } />
                </InputGroup>
            </Center>
            <Tabs width="md">
                <TabList>
                    <Tab>Mint</Tab>
                    <Tab>Deploy</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <VStack>
                            <InputGroup>
                                <InputLeftAddon children='Tick' />
                                <Input type='text' placeholder='ordi/sats/...' value={mintTick}
                                    onChange={e => {
                                        setMintTick(e.target.value);
                                    } } />
                            </InputGroup>
                            {/* <HStack>
                                <NumberInput allowMouseWheel value={mintAmount} defaultValue={1000} min={1} max={Number.MAX_VALUE}
                                    onChange={e => setMintAmount(parseInt(e))}>
                                    <NumberInputField />
                                    <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper>
                                </NumberInput>
                            </HStack> */}
                            <InputGroup>
                                <InputLeftAddon children='Amount' />
                                <Input type='number' placeholder='1000' min={1}
                                    value={mintAmount}
                                    onChange={e => {
                                        setMintAmount(parseInt(e.target.value));
                                     } } />
                            </InputGroup>
                            <Textarea value={mintText}/>
                            <Textarea value={mintHex}/>
                            <Center>
                                <Button isDisabled={currentChain.length === 0} onClick={prepareMint}>1. Prepare</Button>
                                <Button isLoading={minting} isDisabled={currentChain.length === 0} onClick={mint}>2. Mint</Button>
                            </Center>
                        </VStack>
                    </TabPanel>
                    <TabPanel>
                        <VStack>
                            <InputGroup>
                                <InputLeftAddon children='Tick' />
                                <Input type='text' placeholder='ordi/sats/...' value={deployTick}
                                    onChange={e => {
                                        setDeployTick(e.target.value);
                                    } } />
                            </InputGroup>
                            <InputGroup>
                                <InputLeftAddon children='Total Supply' />
                                <Input type='number' placeholder='21000000' min={1}
                                    value={deployTotalSupply}
                                    onChange={e => {
                                        setDeployTotalSupply(parseInt(e.target.value));
                                    } } />
                            </InputGroup>
                            <InputGroup>
                                <InputLeftAddon children='Limit per mint' />
                                <Input type='number' placeholder='1000' min={1}
                                    value={deployLimitPerMint}
                                    onChange={e => {
                                        setDeployLimitPerMint(parseInt(e.target.value));
                                    } } />
                            </InputGroup>
                            <Textarea value={deployText}/>
                            <Textarea value={deployHex}/>
                            <Center>
                                <Button isDisabled={currentChain.length === 0} onClick={prepareDeploy}>1. Prepare</Button>
                                <Button isLoading={deploying} isDisabled={currentChain.length === 0} onClick={deploy}>2. Deploy</Button>
                            </Center>
                        </VStack>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <Footer />
        </VStack>
    );
}